module.exports = __webpack_public_path__ + "img/039-later.47425af1.svg";